import React, { Fragment } from "react";
import styled from "styled-components";
import COLORS from "../../../assets/Colors";
import theme from "../../../assets/theme";

const ActionBar = ({
  actions = [],
  breadcrumbs = [],
  onBreadcrumbClick = () => {},
}) => {
  return (
    <ActionBarContainer>
      <Breadcrumbs>
        {breadcrumbs.map((breadcrumb, index) => (
          <Fragment key={`breadcrumb-${breadcrumb}-${index}`}>
            <Breadcrumb onClick={() => onBreadcrumbClick(breadcrumbs[index])}>
              {breadcrumb}
            </Breadcrumb>
            {index < breadcrumbs.length - 1 && <Breadcrumb>{">"}</Breadcrumb>}
          </Fragment>
        ))}
      </Breadcrumbs>
      <ActionButtonContainer>
        {actions.map((action, index) => (
          <ActionButton
            key={`action-${action.text}-${index}`}
            {...action.props}
          >
            {action.text}
          </ActionButton>
        ))}
      </ActionButtonContainer>
    </ActionBarContainer>
  );
};

export default ActionBar;

const ActionBarContainer = styled.div`
  border-bottom: 1px solid ${COLORS.BORDER_GREY};
  padding: 0px 53px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 55px;
`;

const ActionButton = styled.button`
  border-radius: 4px;
  border: 0;
  background-color: ${COLORS.BTN_GREEN};
  width: 171px;
  height: 40px;
  font-family: ${theme.fonts.primaryFontBold};
  font-size: 14px;
  text-align: center;
  color: ${COLORS.PRIMARY_WHITE};
  outline: none;
  &:hover {
    opacity: 0.8;
    cursor: pointer;
  }
  margin-left: 23px;
`;

const ActionButtonContainer = styled.div`
  display: flex;
  align-items: center;
`;

const Breadcrumbs = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const Breadcrumb = styled.div`
  font-size: 14px;
  font-family: ${theme.fonts.primaryFontSemiBold};
  margin-right: 4px;
  cursor: pointer;
  color: ${COLORS.COLOR_DARK};
  user-select: none;
`;
